import React from "react";
import { Container } from "react-bootstrap";
import AboutImg from "../../Assets/AboutImg.svg";

const About = () => {
  const fontSize = {
    fontSize: "1.07rem",
  };
  return (
    <Container>
      <div
        id="about"
        className="d-flex flex-column-reverse my-5 flex-lg-row mx-auto text-center"
      >
        <div className="col-12 col-lg-6">
          <div
            className="row text-center pt-0 pt-md-2 pt-lg-5 mb-4"
            data-aos="fade-right"
          >
            <div className="col">
              <img
                src={AboutImg}
                style={{ maxHeight: "24rem" }}
                alt="ThumbsUp"
                className="img-fluid h-100 w-100"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 pl-3">
          <div
            className="pt-0 pt-lg-3 my-0 my-lg-5 text-center text-lg-start px-3"
            data-aos="fade-left"
            style={fontSize}
          >
            <h2 className="fw-semibold mt-3 my-lg-3">Who We Are</h2>
            <p
              className="py-2 py-md-3 lead lh-lg text-center text-lg-start fs-md-0 w-100 mb-4"
              style={{ fontSize: 17 }}
            >
              Logistat is a Logistic-as-a-service (LaaS) technology platform
              that enables logistic companies in emerging markets to automate
              and scale their courier businesses by providing managed IT and
              business support services and fully customizable web and mobile
              user applications at an affordable rate.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default About;
